
import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  structuredData?: object;
}

export const SEO = ({ title, description, keywords, structuredData }: SEOProps) => {
  useEffect(() => {
    // Update title
    if (title) {
      document.title = title;
    }

    // Update meta description
    if (description) {
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      } else {
        const meta = document.createElement('meta');
        meta.name = 'description';
        meta.content = description;
        document.head.appendChild(meta);
      }
    }

    // Update meta keywords
    if (keywords) {
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords);
      } else {
        const meta = document.createElement('meta');
        meta.name = 'keywords';
        meta.content = keywords;
        document.head.appendChild(meta);
      }
    }

    // Add structured data
    if (structuredData) {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.textContent = JSON.stringify(structuredData);
      } else {
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.textContent = JSON.stringify(structuredData);
        document.head.appendChild(script);
      }
    }
  }, [title, description, keywords, structuredData]);

  return null;
};

export const getStructuredData = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "PRIMECONDOMINIALSOLUCOES",
    "description": "Serviços especializados para prédios e condomínios em Canoas RS",
    "url": siteUrl,
    "logo": `${siteUrl}/logo.png`,
    "image": `${siteUrl}/hero-image.jpg`,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rua Tiradentes, 764",
      "addressLocality": "Canoas",
      "addressRegion": "RS",
      "postalCode": "92020-000",
      "addressCountry": "BR"
    },
    "telephone": "(51) 99567-0049",
    "email": "primecondominialsolucoes@gmail.com",
    "openingHoursSpecification": {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      "opens": "08:00",
      "closes": "18:00"
    },
    "serviceArea": {
      "@type": "GeoCircle",
      "geoMidpoint": {
        "@type": "GeoCoordinates",
        "latitude": -29.9175,
        "longitude": -51.1807
      },
      "geoRadius": "50000"
    },
    "priceRange": "$$",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "150"
    },
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Serviços para Condomínios",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Manutenção Predial",
            "description": "Serviços completos de manutenção preventiva e corretiva"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Administração Predial",
            "description": "Gestão completa de condomínios e prédios residenciais"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Segurança 24h",
            "description": "Serviços de portaria e segurança patrimonial"
          }
        }
      ]
    }
  };
};

export const getFAQStructuredData = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Quais serviços a PRIMECONDOMINIALSOLUCOES oferece?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Oferecemos manutenção predial, administração de condomínios, segurança 24h, jardinagem, limpeza especializada e reformas para prédios e condomínios em Canoas RS."
        }
      },
      {
        "@type": "Question",
        "name": "Qual a área de atendimento da empresa?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Atendemos principalmente Canoas e região metropolitana de Porto Alegre, Rio Grande do Sul."
        }
      },
      {
        "@type": "Question",
        "name": "Como posso solicitar um orçamento?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Você pode entrar em contato conosco pelo telefone (51) 99567-0049, email primecondominialsolucoes@gmail.com ou através do formulário em nosso site."
        }
      }
    ]
  };
};
